<template>
    <div class="DayProfit">
        <NoData v-if="dayProfit.length<=0" :isTrade="isTrade"></NoData>
        <ul v-else>
            <li v-for="item in dayProfit" v-if="item.Reason != constant.DealReason.OPEN && item.Reason != constant.DealReason.LIMIT && item.Reason != constant.DealReason.STOP">
                <div class="itemTit">
                    <div class="leftCon"><span>{{item.SName.szShortName}}</span><p>#{{item.ID}}</p></div>
                    <div class="rightCon">
                        <div class="rightCon"><div class="item"><time>{{item.ExecuteTime|time}}</time></div></div>
                    </div>
                </div>
                <div class="itemCon">
                    <div class="leftCon">
                        <div class="itemList">
                            <div class="item"><em :class="cutover(tradeUtil.OrderDirection[item.Direction])">{{tradeUtil.OrderDirection[item.Direction]}}</em><p>{{item.ExecuteVolume}}</p></div>
                            <div class="item"><span>{{$t('success.executePrice')}}</span><p>{{item.SrcPrice}}</p></div>
                            <div class="item"><span>{{$t('success.openingPrice')}}</span><p>{{item.ExecutePrice}}</p></div>
                        </div>
                        <div class="itemList">
                            <div class="item"><span>{{$t('success.interest')}}</span><p v-if="item.Swap">{{item.Swap > 0?'+':'-'}}${{item.Swap>0?item.Swap.replace("+", ""):item.Swap.replace("-", "")}}</p></div>
                            <div class="item"><span>{{$t('success.commission')}}</span><p v-if="item.Commission">{{item.Commission >= 0?'':'-'}}${{item.Commission>=0?item.Commission.replace("+", ""):item.Commission.replace("-", "")}}</p></div>
                            <div class="item"><p class="size" :class="Gain(item.Profit)"><em>+</em>{{item.Profit}}</p></div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    import Constant from '@/utils/Constant'
    import NoData from '@/view/module/NoData.vue'
    export default {
        name: "DayProfit",
        filters: {
            time(longTime) {
                return Util.formatDate(longTime,"yyyy-MM-dd hh:mm:ss");
            }
        },
        components:{NoData},
        computed: {
            ...mapState(['tradeData', 'quote']),
            dayProfit:{
                get(){
                    return TradeUtil.copy(this.tradeData.dayDeal).filter(item => (item.Reason != Constant.DealReason.OPEN && item.Reason != Constant.DealReason.LIMIT && item.Reason != Constant.DealReason.STOP));
                }
            }
        },
        data(){
            return {
                util:Util,
                tradeUtil:TradeUtil,
                constant:Constant,
                isTrade:true
            }
        },
        methods:{
            cutover:function(obj){
                let val;
                if (obj==this.$t('trade.products.buy')){
                    val="buy"
                }else if(obj==this.$t('trade.products.sell')){
                    val="sell"
                }
                return val;
            },
            Gain:function(obj){
                let val;
                if (obj>0){
                    val="rise";
                }else if(obj==0){
                    val="level";
                }else {
                    val="fall";
                }
                return val;
            },
        }
    }
</script>
